export const TEXT_SHOULD_FORWARD_PROP = [
  'accent',
  'disabled',
  'primary',
  'secondary',
  'body',
  'danger',
  'heading',
  'important',
  'inverse',
  'muted',
  'success',
  'warning',
  'body1',
  'body2',
  'caption',
  'header5',
  'header6',
  'overline',
  'action1',
  'action2',
  'action3',
  'action4',
  'action5',
  'body3',
  'body4',
  'body5',
  'caption1',
  'caption2',
  'caption3',
  'caption4',
  'header1',
  'header2',
  'header3',
  'header4',
  'subheader1',
  'subheader2',
  'subheader3',
  'subheader4',
  'subtitle1',
  'subtitle2',
  'subtitle3',
  'subtitle4',
  'left',
  'center',
  'right',
  'monospace',
  'uppercase',
  'capitalize',
  'ellipsis',
  'regular',
  'medium',
  'bold',
  'screen14',
  'screen16',
  'screen18',
  'screen20',
  'screen24',
  'screen28',
  'screen32',
  'screen36',
  'screen38',
  'screen40',
  'screen52',
  'screen64',
  'nowrap',
  'preWrap',
  'maxWidth',
  'minHeight',
  'lineHeight',
]

export const DIV_SHOULD_FORWARD_PROP = [
  'alignCenter',
  'alignEnd',
  'alignItems',
  'alignStart',
  'backgroundColor',
  'borderBottom',
  'borderTop',
  'children?:',
  'classNam',
  'flexDirection',
  'flexGrow',
  'fullHeight',
  'fullScreen',
  'fullWidth',
  'gridTemplateColumns',
  'grow',
  'justifyCenter',
  'justifyContent',
  'justifyEnd',
  'maxHeight',
  'maxWidth',
  'minHeight',
  'noShrink',
  'overflowY',
  'pointer',
  'relative',
  'spaceBetween',
  'squeeze',
  'wrap',
  'zIndex',
]
